// For deployment
 export const API_BASE_URL = 'https://game-buddy-app.onrender.com';
// For Local Use
// export const API_BASE_URL = 'http://localhost:5000';